module.exports = __webpack_public_path__ + "img/sld_scb_12_t1_green.3e3228af.svg";